import {inject, Injectable, signal} from '@angular/core';
import {TelegramAccount} from "../types/telegram-page.types";
import {TelegramService} from "./telegram.service";
import {defaultAccount} from "../configs/telegram-accounts-config";

@Injectable({
  providedIn: 'root'
})
export class TelegramAccountsService {
  private telegramService: TelegramService = inject(TelegramService);
  private _accounts = signal<Array<TelegramAccount>>([]);
  public accounts = this._accounts.asReadonly();
  private _selectedAccount = signal<TelegramAccount>(defaultAccount);
  public selectedAccount = this._selectedAccount.asReadonly();

  public async loadAccounts(): Promise<void> {
    const accounts = await this.getAccounts();
    this._accounts.set(accounts);
  }

  public setSelectedAccount(account: TelegramAccount): void {
    this._selectedAccount.set(account);
  }

  private async getAccounts(): Promise<Array<TelegramAccount>> {
    return  await this.telegramService.getAccounts().catch(() => []);
  }
}
